/** Clase encargada de crear el identificador tipo slug para las palabras que le llegan*/
export class StringUtil {
  static slugify(text: string): string {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }

  /**
   *  clase encargada de generar una palabra aleatoria.
   * @param length Parametro que recibe el tamaño de la palabra que se generará.
   */
  static randomString(length: number): string {
    let text = '';
    const possible =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }

  /** Función estatica que que convierte una lista de strings a un formato de slugfy de ruta*/
  static listStringToSlugifyRoute(strings: Array<string>): string {
    return strings.map((s) => StringUtil.slugify(s)).join('/');
  }

  static capitalizeEachWord(text: string): string {
    if (!text) return text; // Manejar cadenas vacías
    return text
      .split(' ') // Dividir el texto en palabras
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalizar cada palabra
      .join(' '); // Unir las palabras nuevamente
  }

  static format(template: string, ...args: any[]): string {
    let i = 0;
    return template.replace(/{}/g, () =>
      typeof args[i] !== 'undefined' ? args[i++] : ''
    );
  }
}
